import {useEffect, useRef, useState} from 'react'


import '../assets/css/programacao.css'
import LateralMenu from './LateralMenu';
import BoxComp from './BoxComp.jsx';
import GlobalVars from './subComponents/GlobalVars.jsx';

// var width_ = window.innerWidth;
// var height_ = window.innerHeight;

export const Programacao = ({ativaResp}) => {

  const lateralMenu = useRef()
  const programacao = GlobalVars.programacao

  const [animate1, setAnimate1] = useState(false)
  const [animateOut, setAnimateOut] = useState(false)

  useEffect(()=>{
    setTimeout(()=>{setAnimate1(true)},500)
    setTimeout(()=>{setAnimateOut(true)},1000)
  })

    return <>
        <LateralMenu ativaResp={ativaResp} ref={lateralMenu}/>
        <div className="containerPrincipal programacao" style={{maxHeight: "100vh"}}>
        <BoxComp lateralMenu={lateralMenu}/>
        <div className="containerProgramacao">
            <div className="titlePage">Programação</div>


            <div className="horariosProg">
                <div className="titleSub titleSemanal">Semanal</div>
                <div className="semanal" style={{transform: animate1 ? 'translateX(0%)' : 'translateX(-150%)'}}>
                    {programacao ? programacao.Semanal.map((val)=>{
                        return <div className="cardProgamacao">
                            <div className="leftCard">
                                <div className="dayCard">{val.day}</div>
                                <div className="hourCard">{val.hour}</div>
                            </div>
                            <div className="rightCard">{val.title}</div>
                        </div>
                    }) : <></>
                }
                </div>


                <div className="titleSub titleMensal">Mensal</div>
                <div className="mensal" style={{transform: animate1 ? 'translateX(0%)' : 'translateX(-150%)'}}>
                    {programacao ? programacao.Mensal.map((val)=>{
                        return <div className="cardProgamacao">
                            <div className="leftCard">
                                <div className="dayCard">{val.day}</div>
                                <div className="rightCard">{val.title}</div>
                            </div>
                                <div className="hourCard">{val.hour}</div>
                        </div>
                    }) : <></>
                }
                </div>

            </div>

        </div>

        </div>
    </>
}

export default Programacao;